export default __webpack_public_path__ + "static/media/40194.e7636874.jpg";